import styled from 'styled-components';

export const Subtitle = styled.div``;
